import { IMapLand } from 'models/MapLand';
import { MOCK_HRC721 } from './constants';
import mockNfts from './nfts';

const mapLands: IMapLand[] = mockNfts
  .filter(nft => nft.category === 'land')
  .map(nft => ({
    _id: nft._id,
    tokenId: nft.tokenId,
    contract: MOCK_HRC721,
    attributes: {
      COORDINATES: nft.attributes.COORDINATES,
      REGION: nft.attributes.REGION,
    },
    sale: nft.sale ? { status: nft.sale.status } : {},
  }));

export default mapLands;
